import {defineAsyncComponent} from 'vue';

export const componentMap = {
  Shove: defineAsyncComponent(() => import('./NotificationShove.vue')),
  Bag: defineAsyncComponent(() => import('./NotificationBag.vue')),
  Simple: defineAsyncComponent(() => import('./NotificationSimple.vue')),
};
